/**
 * 认证产品类型枚举
 * 对应 CertificationProductTypeEnum
 */
import GenerateEnum from '../generateEnum'

const CERTIFICATION_PRODUCT_TYPE = new GenerateEnum({
  ADULT_CLOTHING: {
    value: '1',
    label: '成人服装',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  POWER_BANK: {
    value: '2',
    label: '储能电池（充电宝）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  ELECTRIC_TOY: {
    value: '3',
    label: '带电玩具',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  LAMP_PRODUCT: {
    value: '4',
    label: '灯具产品',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  BATTERY_IN_APPLIANCE: {
    value: '5',
    label: '电器中的电池（≤5kg）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  CHILDREN_CLOTHING: {
    value: '6',
    label: '儿童服装',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  WIRELESS_APPLIANCE: {
    value: '7',
    label: '含无线功能的电器',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  CHEMICAL: {
    value: '8',
    label: '化学品',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  LASER_PRODUCT: {
    value: '9',
    label: '激光产品',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  COMMON_APPLIANCE: {
    value: '10',
    label: '普通电器',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  COMMON_TOY: {
    value: '11',
    label: '普通玩具',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  OTHER_SERVICE_1: {
    value: '12',
    label: '其他产品（人工服务）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  DISINFECT_PRODUCT: {
    value: '13',
    label: '杀菌消毒灭虫类产品',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  FOOD_CONTACT_PRODUCT: {
    value: '14',
    label: '食品接触产品',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  JEWELRY: {
    value: '15',
    label: '饰品',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  SANITARY_PRODUCT: {
    value: '16',
    label: '卫浴产品',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  ELECTRIC_LIGHT_TOY: {
    value: '17',
    label: '带电带光玩具',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_DRY_BATTERY: {
    value: '18',
    label: '带电玩具（干电池）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_LITHIUM: {
    value: '19',
    label: '带电玩具（锂电池）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  COMMON_TOY_OVER_3: {
    value: '20',
    label: '普通玩具（3岁以上）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  COMMON_TOY_UNDER_3: {
    value: '21',
    label: '普通玩具（3岁以下）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_OVER_3: {
    value: '22',
    label: '带电玩具（3岁以上）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_UNDER_3: {
    value: '23',
    label: '带电玩具（3岁以下）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  OTHER_SERVICE_2: {
    value: '24',
    label: '其他产品（人工服务）',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  TOY_REPORT_CHECK: {
    value: '25',
    label: '玩具报告审核校验',
    needTestPointPrice: false,
    needColorCountPrice: false
  },
  PLUSH_TOY: {
    value: '26',
    label: '毛绒玩具',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  PLASTIC_TOY: {
    value: '27',
    label: '塑料玩具',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  BATH_TOY: {
    value: '28',
    label: '沐浴玩具',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  FINGER_PAINT_NORMAL: {
    value: '29',
    label: '指画颜料-普通颜料',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  FINGER_PAINT_SPECIAL: {
    value: '30',
    label: '指画颜料-专标颜料',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ACTIVITY_TOY: {
    value: '31',
    label: '活动玩具',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  HOME_TRAMPOLINE: {
    value: '32',
    label: '家用蹦床',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_LT_15V: {
    value: '33',
    label: '带电玩具-小于15V',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_GT_15V: {
    value: '34',
    label: '带电玩具-大于15V',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_LIGHT_TOY_LT_15V: {
    value: '35',
    label: '带电带光玩具-小于15V',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_LIGHT_TOY_GT_15V: {
    value: '36',
    label: '带电带光玩具-大于15V',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  FINGER_PAINT_MARKER: {
    value: '37',
    label: '指画颜料-马克笔',
    needTestPointPrice: true,
    needColorCountPrice: true
  },
  FINGER_PAINT_COLOR_PEN: {
    value: '38',
    label: '指画颜料-彩笔',
    needTestPointPrice: true,
    needColorCountPrice: true
  },
  FINGER_PAINT_CRAYON: {
    value: '39',
    label: '指画颜料-蜡笔',
    needTestPointPrice: true,
    needColorCountPrice: true
  },
  FINGER_PAINT_PAINT: {
    value: '40',
    label: '指画颜料-颜料',
    needTestPointPrice: true,
    needColorCountPrice: true
  },
  ELECTRIC_TOY_BUTTON_BATTERY: {
    value: '41',
    label: '带电玩具-纽扣/干电池',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_LITHIUM_BATTERY: {
    value: '42',
    label: '带电玩具-锂电池',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_LIGHT_TOY_BUTTON_BATTERY: {
    value: '43',
    label: '带电带光玩具-纽扣/干电池',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_LIGHT_TOY_LITHIUM_BATTERY: {
    value: '44',
    label: '带电带光玩具-锂电池',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_REMOVABLE_LITHIUM: {
    value: '45',
    label: '带电玩具-可拆卸锂电池',
    needTestPointPrice: true,
    needColorCountPrice: false
  },
  ELECTRIC_TOY_NON_REMOVABLE_LITHIUM: {
    value: '46',
    label: '带电玩具-不可拆卸锂电池',
    needTestPointPrice: true,
    needColorCountPrice: false
  }
})

export { CERTIFICATION_PRODUCT_TYPE }


// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/CertificationProductType.js